// First-party page-view beacon for the public marketing pages.
// Fire-and-forget: analytics must never break or slow down the site.

const API_BASE = import.meta.env.VITE_API_URL || '/api';

let lastTracked = '';
let lastTrackedAt = 0;

export function trackPageView(path: string) {
  // React StrictMode double-invokes effects in dev — don't double-count.
  const now = Date.now();
  if (path === lastTracked && now - lastTrackedAt < 1000) return;
  lastTracked = path;
  lastTrackedAt = now;

  try {
    fetch(`${API_BASE}/page-view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, referrer: document.referrer || undefined }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Never let analytics surface an error to the visitor.
  }
}
